// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itc-busy {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2002;
  background: rgba(255, 255, 255, 0.7803921569);
  opacity: 1;
  text-align: center;
}

.itc-busy-default-sign {
  position: relative;
  display: inline-block;
  z-index: 2003;
  padding: 12px 14px;
  border: 1px solid #d8d8d8;
  margin-top: 2px;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  background: #f8f8f8;
  color: #333;
  opacity: 1;
}

.itc-busy-default-text {
  display: inline-block;
  margin-left: 6px;
  max-width: 400px;
  font-size: 14px;
  text-align: left;
}

/* Start animated loading icon */
.itc-busy-default-spinner {
  position: relative;
  display: inline-block;
  width: 25px;
  height: 25px;
  vertical-align: middle;
}

.itc-busy-default-spinner div {
  position: absolute;
  left: 44.5%;
  top: 37%;
  width: 10%;
  height: 26%;
  border-radius: 50px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  opacity: 0;
  animation: busy-spinner-anim 1s linear infinite;
}

.itc-busy-default-spinner .bar1 {
  transform: rotate(0deg) translate(0, -142%);
  animation-delay: -1s;
}

.itc-busy-default-spinner .bar2 {
  transform: rotate(30deg) translate(0, -142%);
  animation-delay: -0.91666667s;
}

.itc-busy-default-spinner .bar3 {
  transform: rotate(60deg) translate(0, -142%);
  animation-delay: -0.83333333s;
}

.itc-busy-default-spinner .bar4 {
  transform: rotate(90deg) translate(0, -142%);
  animation-delay: -0.75s;
}

.itc-busy-default-spinner .bar5 {
  transform: rotate(120deg) translate(0, -142%);
  animation-delay: -0.66666667s;
}

.itc-busy-default-spinner .bar6 {
  transform: rotate(150deg) translate(0, -142%);
  animation-delay: -0.58333333s;
}

.itc-busy-default-spinner .bar7 {
  transform: rotate(180deg) translate(0, -142%);
  animation-delay: -0.5s;
}

.itc-busy-default-spinner .bar8 {
  transform: rotate(210deg) translate(0, -142%);
  animation-delay: -0.41666667s;
}

.itc-busy-default-spinner .bar9 {
  transform: rotate(240deg) translate(0, -142%);
  animation-delay: -0.33333333s;
}

.itc-busy-default-spinner .bar10 {
  transform: rotate(270deg) translate(0, -142%);
  animation-delay: -0.25s;
}

.itc-busy-default-spinner .bar11 {
  transform: rotate(300deg) translate(0, -142%);
  animation-delay: -0.16666667s;
}

.itc-busy-default-spinner .bar12 {
  transform: rotate(330deg) translate(0, -142%);
  animation-delay: -0.08333333s;
}

@keyframes busy-spinner-anim {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.25;
  }
}`, "",{"version":3,"sources":["webpack://./src/@itc-core/directives/itc-busy/component/itc-busy.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,6CAAA;EACA,UAAA;EACA,kBAAA;AACD;;AAEA;EACC,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,yCAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AACD;;AAEA;EACC,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AACD;;AAEA,gCAAA;AACA;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AACD;;AAEA;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,sCAAA;EACA,UAAA;EACA,+CAAA;AACD;;AAEA;EACC,2CAAA;EACA,oBAAA;AACD;;AAEA;EACC,4CAAA;EACA,6BAAA;AACD;;AAEA;EACC,4CAAA;EACA,6BAAA;AACD;;AAEA;EACC,4CAAA;EACA,uBAAA;AACD;;AAEA;EACC,6CAAA;EACA,6BAAA;AACD;;AAEA;EACC,6CAAA;EACA,6BAAA;AACD;;AAEA;EACC,6CAAA;EACA,sBAAA;AACD;;AAEA;EACC,6CAAA;EACA,6BAAA;AACD;;AAEA;EACC,6CAAA;EACA,6BAAA;AACD;;AAEA;EACC,6CAAA;EACA,uBAAA;AACD;;AAEA;EACC,6CAAA;EACA,6BAAA;AACD;;AAEA;EACC,6CAAA;EACA,6BAAA;AACD;;AAEA;EACC;IACC,UAAA;EACA;EACD;IACC,aAAA;EACA;AACF","sourcesContent":[".itc-busy {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 2002;\n\tbackground: #ffffffc7;\n\topacity: 1;\n\ttext-align: center;\n}\n\n.itc-busy-default-sign {\n\tposition: relative;\n\tdisplay: inline-block;\n\tz-index: 2003;\n\tpadding: 12px 14px;\n\tborder: 1px solid #d8d8d8;\n\tmargin-top: 2px;\n\tborder-radius: 4px;\n\tbox-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\tbackground: #f8f8f8;\n\tcolor: #333;\n\topacity: 1;\n}\n\n.itc-busy-default-text {\n\tdisplay: inline-block;\n\tmargin-left: 6px;\n\tmax-width: 400px;\n\tfont-size: 14px;\n\ttext-align: left;\n}\n\n/* Start animated loading icon */\n.itc-busy-default-spinner {\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 25px;\n\theight: 25px;\n\tvertical-align: middle;\n}\n\n.itc-busy-default-spinner div {\n\tposition: absolute;\n\tleft: 44.5%;\n\ttop: 37%;\n\twidth: 10%;\n\theight: 26%;\n\tborder-radius: 50px;\n\tbox-shadow: 0 0 3px rgba(0, 0, 0, 0.2);\n\topacity: 0;\n\tanimation: busy-spinner-anim 1s linear infinite;\n}\n\n.itc-busy-default-spinner .bar1 {\n\ttransform: rotate(0deg) translate(0, -142%);\n\tanimation-delay: -1s;\n}\n\n.itc-busy-default-spinner .bar2 {\n\ttransform: rotate(30deg) translate(0, -142%);\n\tanimation-delay: -0.91666667s;\n}\n\n.itc-busy-default-spinner .bar3 {\n\ttransform: rotate(60deg) translate(0, -142%);\n\tanimation-delay: -0.83333333s;\n}\n\n.itc-busy-default-spinner .bar4 {\n\ttransform: rotate(90deg) translate(0, -142%);\n\tanimation-delay: -0.75s;\n}\n\n.itc-busy-default-spinner .bar5 {\n\ttransform: rotate(120deg) translate(0, -142%);\n\tanimation-delay: -0.66666667s;\n}\n\n.itc-busy-default-spinner .bar6 {\n\ttransform: rotate(150deg) translate(0, -142%);\n\tanimation-delay: -0.58333333s;\n}\n\n.itc-busy-default-spinner .bar7 {\n\ttransform: rotate(180deg) translate(0, -142%);\n\tanimation-delay: -0.5s;\n}\n\n.itc-busy-default-spinner .bar8 {\n\ttransform: rotate(210deg) translate(0, -142%);\n\tanimation-delay: -0.41666667s;\n}\n\n.itc-busy-default-spinner .bar9 {\n\ttransform: rotate(240deg) translate(0, -142%);\n\tanimation-delay: -0.33333333s;\n}\n\n.itc-busy-default-spinner .bar10 {\n\ttransform: rotate(270deg) translate(0, -142%);\n\tanimation-delay: -0.25s;\n}\n\n.itc-busy-default-spinner .bar11 {\n\ttransform: rotate(300deg) translate(0, -142%);\n\tanimation-delay: -0.16666667s;\n}\n\n.itc-busy-default-spinner .bar12 {\n\ttransform: rotate(330deg) translate(0, -142%);\n\tanimation-delay: -0.08333333s;\n}\n\n@keyframes busy-spinner-anim {\n\tfrom {\n\t\topacity: 1;\n\t}\n\tto {\n\t\topacity: 0.25;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
